import React from "react";

import { FormField, InputWrapper, Text } from "@performyard/py-components";

import { SingleEmployee } from "../../../../components/EmployeePicker";
import { ManagersTable } from "./ManagersTable";

// type ApprovalTypeInputProps = {
// 	value: "manager" | "chain";
// 	onChange: (value: "manager" | "chain") => void;
// 	onBlur: () => void;
// };

// const ApprovalTypeInput = ({ value, onChange, onBlur }: ApprovalTypeInputProps) => {
// 	const options = [
// 		{ label: "Single Approval", value: "manager" as const, description: "Manager approves compensation changes" },
// 		{
// 			label: "Chain of Command",
// 			value: "chain" as const,
// 			description: "Full chain of command reviews and approves",
// 		},
// 	];

// 	return (
// 		<div className="grid grid-cols-2 gap-2">
// 			{options.map((option) => (
// 				<button
// 					type="button"
// 					key={option.value}
// 					className={`cursor-pointer rounded-1 border border-solid border-neutral-2 bg-neutral-0 p-4 text-left`}
// 					onClick={() => {
// 						onChange(option.value);
// 						onBlur();
// 					}}
// 				>
// 					<div className={`mb-2 flex items-start justify-between gap-3`}>
// 						<Text htmlFor={`${option.value}-approval-type`} size="paragraph-2" weight="semi-bold">
// 							{option.label}
// 						</Text>
// 						<div
// 							className={`flex size-3 items-center justify-center rounded-full border border-solid border-neutral-2 ${value === option.value ? "border-primary-5 bg-primary-5" : "border-neutral-1"}`}
// 						>
// 							<div className={`size-1.5 rounded-full bg-neutral-0`} />
// 						</div>
// 						<input
// 							id={`${option.value}-approval-type`}
// 							type="radio"
// 							name="approvalType"
// 							value={option.value}
// 							checked={value === option.value}
// 							onChange={() => onChange(option.value)}
// 							onBlur={onBlur}
// 							// if checked, color primary-5
// 							className={`hidden`}
// 						/>
// 					</div>
// 					<Text size="paragraph-3">{option.description}</Text>
// 				</button>
// 			))}
// 		</div>
// 	);
// };

type ApprovalChainStepProps = {
	userSelectionId: string;
};

const ApprovalChainStep = ({ userSelectionId }: ApprovalChainStepProps) => {
	return (
		<div className="mx-auto flex max-w-[1100px] flex-col gap-8">
			<div className="text-center">
				<Text size="sub-heading" weight="semi-bold">
					Create a Compensation Cycle
				</Text>
				<Text size="paragraph-2" weight="regular">
					Cycle Managers
				</Text>
			</div>

			{/* <FormField<"manager" | "chain">
				id="approvalType"
				input={({ value, onChange, onBlur, errors }) => {
					return (
						<InputWrapper id="approvalType" error={errors.join(", ")}>
							<ApprovalTypeInput value={value} onChange={onChange} onBlur={onBlur} />
						</InputWrapper>
					);
				}}
			/> */}

			<FormField<Record<string, SingleEmployee>>
				id="managerOverrides"
				input={({ value, onChange, onBlur, errors }) => {
					return (
						<InputWrapper id="managerOverrides" error={errors.join(", ")}>
							<ManagersTable
								userSelectionId={userSelectionId}
								value={value}
								onChange={onChange}
								onBlur={onBlur}
							/>
						</InputWrapper>
					);
				}}
			/>
		</div>
	);
};

export default ApprovalChainStep;
